// cart sidebar js start
  class SidebarDrawer extends HTMLElement {
    open() { this.setAttribute('open', '');  initCustomSlickSlider(this.querySelector('#recently-viewed'));  }
    close() { this.removeAttribute('open'); }
    connectedCallback() {
      this.querySelector('.close-btn')
        .addEventListener('click', () => this.close());
    }
  }
  customElements.define('sidebar-drawer', SidebarDrawer);

  document.addEventListener('DOMContentLoaded', function() {
    var sidebar = document.querySelector('sidebar-drawer');
    var cartIcon = document.getElementById('headerCartIcon');

    // Add this block for the cart icon
    if(cartIcon && sidebar) {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        sidebar.open();
       
      });
    }
  });
// cart sidebar js end


function initCustomSlickSlider(container) {
  
  $(container).find('.custom-slick-slider').each(function(){
    var $slider = $(this);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    // Dynamic attributes
    var slidesMobile = parseInt($slider.data('slides-mobile')) || 1;
    var slidesTablet = parseInt($slider.data('slides-tablet')) || 2;
    var slidesDesktop = parseInt($slider.data('slides-desktop')) || 4;
    var autoplay = $slider.data('autoplay') === true || $slider.data('autoplay') === 'true';
    var speed = parseInt($slider.data('speed')) || 3000;
    var speed = parseInt($slider.data('speed')) || 3000; 
    var showArrows = $slider.data('arrows') === true || $slider.data('arrows') === 'true';
    var showDots = $slider.data('dots') === true || $slider.data('dots') === 'true';


    // Initialize slick
    $slider.slick({
      slidesToShow: slidesDesktop,
      slidesToScroll: 1,
      dots: showDots,
      arrows: showArrows,
      autoplay: autoplay,
      autoplaySpeed: speed,
      prevArrow: `<button type="button" class="slick-prev slick-arrow" aria-label="Previous">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next slick-arrow" aria-label="Next">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>`,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: slidesTablet } },
        { breakpoint: 768, settings: { slidesToShow: slidesMobile } }
      ]
    });
  });
}

// 🔹 Normal frontend load
$(document).ready(function(){
  initCustomSlickSlider(document);
});

// 🔹 Shopify Editor Events
document.addEventListener('shopify:section:load', function(event) {
  initCustomSlickSlider(event.target);
});

document.addEventListener('shopify:section:select', function(event) {
  initCustomSlickSlider(event.target);
});

document.addEventListener('shopify:block:select', function(event) {
  initCustomSlickSlider(event.target);
});

document.addEventListener('shopify:block:deselect', function(event) {
  initCustomSlickSlider(event.target);
});

// 🔹 Fallback: har section change ke baad puri page me dobara init
document.addEventListener('shopify:section:deselect', function() {
  initCustomSlickSlider(document);
});


// Tab click logic
$(document).on('click', '.tab-link', function () {
  const tabId = $(this).data('tab');

  // switch active tab/link
  $(this).addClass('active').siblings().removeClass('active');
  $('#' + tabId).addClass('active').siblings('.tab-content').removeClass('active');

  // :large_green_circle: Re-init slick for sliders inside the newly opened tab
  initCustomSlickSlider('#' + tabId);
});

// OLD JS 

// $(document).ready(function(){
//   $('.custom-slick-slider').each(function(){
//     var $slider = $(this);

//     // Dynamic attributes
//     var slidesMobile = parseInt($slider.data('slides-mobile')) || 1;
//     var slidesTablet = parseInt($slider.data('slides-tablet')) || 2;
//     var slidesDesktop = parseInt($slider.data('slides-desktop')) || 4;
//     var autoplay = $slider.data('autoplay') === true || $slider.data('autoplay') === 'true';
//     var speed = parseInt($slider.data('speed')) || 3000;
//     var showArrows = $slider.data('arrows') === true || $slider.data('arrows') === 'true';
//     var showDots = $slider.data('dots') === true || $slider.data('dots') === 'true';

//     // Initialize slick
//     $slider.slick({
//       slidesToShow: slidesDesktop,
//       slidesToScroll: 1,
//       dots: showDots,
//       arrows: showArrows,
//       autoplay: autoplay,
//       autoplaySpeed: speed,
//       prevArrow: `<button type="button" class="slick-prev slick-arrow" aria-label="Previous">
//                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                     </svg>
//                   </button>`,
//       nextArrow: `<button type="button" class="slick-next slick-arrow" aria-label="Next">
//                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                     </svg>
//                   </button>`,
//       responsive: [
//         { breakpoint: 1024, settings: { slidesToShow: slidesTablet } },
//         { breakpoint: 768, settings: { slidesToShow: slidesMobile } }
//       ]
//     });
//   });
// });
